module.exports = __webpack_public_path__ + "assets/img/kv-7ab01737.jpg";